import * as timbratureActionsType from "../../actions/actionsTypes/timbraturaActionsType";
import {ofType} from "redux-observable";
import {switchMap} from "rxjs/operators";
import {of} from "rxjs";
import {loadingOverlayActions} from '../../actions'

const actions = [
    timbratureActionsType.ADD_TIMBRATURA_MANUALE_ACTION
];

export const startLoading = (actions$) =>
    actions$.pipe(
        ofType(...actions),
        switchMap(() => of(loadingOverlayActions.showLoadingOverlay()))
    );

